//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "backbone",
  "marionette",
  "underscore",
  "messaging/messenger",
  "./usersSelectView",
], function (Backbone, Marionette, _, Messenger, UsersSelectView) {
  "use strict";

  var UsersSelectController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "usersSelect";
      this.tenant = options.tenant;
      this._setUpVents();
    },
    show: function (department, kbId, localeId) {
      this.filteredUsers = new Backbone.Collection([], {
        comparator: function (a, b) {
          return Backbone.textComparator(a, b, "userFullName");
        },
      });
      this.departmentUsers = department.users();
      this.tenantUsers = Messenger.reqres.request("tenant:users", this.tenant.id);
      this.selectedKbId = kbId;
      this.selectedLocaleId = localeId;
      this.view = new UsersSelectView.usersSelectView({
        collection: this.filteredUsers,
        model: new Backbone.Model({
          tenantUsers: this.tenantUsers,
        }),
      });
      this.view.on("user:add", this._onUserAdd, this);
      this.view.on("itemview:user:remove", this._onUserRemove, this);
      this.showRegion(this.view, { loading: true, entity: this.departmentUsers });
      this.departmentUsers.onSynced(function () {
        this.tenantUsers.onSynced(function () {
          this._filterUsers();
          this.showRegion(this.view);
        }, this);
      }, this);
    },
    _createFilteredUser: function (user) {
      return new Backbone.Model({
        id: user.get("userId"),
        userId: user.get("userId"),
        userFullName: user.get("userFullName"),
        userLoginId: user.get("userLoginId"),
      });
    },
    _filterUsers: function () {
      var selectedKbId = this.selectedKbId;
      var selectedLocaleId = this.selectedLocaleId;
      var selectedUsers = [];
      this.departmentUsers.each(function (departmentUser) {
        if (
          departmentUser.get("languageId") == selectedLocaleId &&
          departmentUser.get("kbId") == selectedKbId
        ) {
          var tenantUser = this.tenantUsers.get(departmentUser.get("userId"));
          if (tenantUser) {
            selectedUsers.push(this._createFilteredUser(tenantUser));
          }
        }
      }, this);
      this.filteredUsers.reset(selectedUsers);
    },
    _onUserAdd: function () {
      var userId = this.view.getUser();
      if (userId) {
        var tenantUser = this.tenantUsers.get(userId);
        if (tenantUser) {
          this.departmentUsers.addUser(userId, this.selectedKbId, this.selectedLocaleId);
          this.filteredUsers.add(this._createFilteredUser(tenantUser));
        }
      }
    },
    _onUserRemove: function (view) {
      var model = view.model;
      var userId = model.id;
      var departmentUser = this.departmentUsers.findWhere({
        userId: userId,
        kbId: this.selectedKbId,
        languageId: this.selectedLocaleId,
      });
      if (departmentUser) {
        this.departmentUsers.remove(departmentUser);
      }
      var user = this.filteredUsers.get(userId);
      if (user) {
        this.filteredUsers.remove(user);
      }
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "department:kb:changed",
        function (kbId) {
          this.selectedKbId = kbId;
          this._filterUsers();
        },
        this,
      );
      Messenger.vent.on(
        "department:locale:changed",
        function (localeId) {
          this.selectedLocaleId = localeId;
          this._filterUsers();
        },
        this,
      );
    },
  });

  return UsersSelectController;
});
